<template>
  <span class="wloading">
    <img v-for="(n, key) in numbers" v-bind:key="key" src="@/assets/loading.gif" class="loading">
  </span>
</template>
<script>
export default {
  name: 'DisplayWaiting',
  props: {
    length: {
      type: [Number, String],
      default: 4
    }
  },
  computed: {
    numbers() {
      return new Array(+this.length)
    }
  }
}
</script>
<style lang="scss" scoped>
.wloading {
  img {
    width: 18px;
    margin: 0 2px;
  }
}

@media(max-width:600px) {
  .wloading {
    img {
      width: 16px;
    }
  }
}

@media(max-width:500px) {
  .wloading {
    img {
      width: 15px;
    }
  }
}

@media(max-width:400px) {
  .wloading {
    img {
      width: 14px;
      margin: 0 1px;
    }
  }
}

@media(max-width:350px) {
  .wloading {
    img {
      width: 12px;
      margin: 0 1px;
    }
  }
}
</style>
